import type { TaxonomyChannelLimit } from '@/entities/taxonomy';

/**
 * Built-in taxonomy character caps by platform — best-effort industry defaults,
 * applied automatically when a platform is selected and OVERRIDABLE per schema
 * (see `TaxonomySettings.channelLimits`). Keys match `TAXONOMY_PLATFORM_OPTIONS`.
 * These are conservative starting points, not gospel; teams tune them per client.
 */
export const PLATFORM_CHAR_LIMITS: Record<string, number> = {
  Meta: 400,
  TikTok: 512,
  YouTube: 100,
  CM360: 255,
  DV360: 240,
  TTD: 255,
  Hulu: 255,
  CTV: 255,
  'Google Ads': 255,
  LinkedIn: 255,
  Reddit: 1024,
};

/** Effective limit for a platform: schema override wins, else the built-in default. */
export function resolveChannelLimit(
  platform: string,
  overrides?: TaxonomyChannelLimit[],
): number | undefined {
  const override = overrides?.find((o) => o.platform === platform);
  if (override) return override.limit;
  return PLATFORM_CHAR_LIMITS[platform];
}
